import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { useLang } from "../store";
import { useT } from "../i18n";

export default function FAQ() {
  const { lang } = useLang();
  const t = useT(lang);
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="bg-[#FAF9F6] border-b-[3px] border-[#0C0A09]">
      <div className="max-w-4xl mx-auto px-5 md:px-10 py-20 md:py-28">
        <div className="text-center mb-12">
          <span className="nb-badge">{t.faq.eyebrow}</span>
          <h2 className="font-display text-5xl md:text-7xl leading-none tracking-tight mt-4">{t.faq.title}</h2>
        </div>
        <div className="space-y-4">
          {t.faq.items.map((item, i) => {
            const isOpen = open === i;
            return (
              <div
                key={item.q}
                className="bg-white border-[3px] border-[#0C0A09] shadow-[5px_5px_0_0_#0C0A09]"
                data-testid={`faq-item-${i}`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  data-testid={`faq-toggle-${i}`}
                  className="w-full flex items-center justify-between p-5 md:p-6 text-left"
                >
                  <span className="font-display text-2xl md:text-3xl leading-tight pr-4">{item.q}</span>
                  <span className="w-10 h-10 rounded-full bg-[#9BE800] border-[3px] border-[#0C0A09] flex items-center justify-center flex-shrink-0">
                    {isOpen ? <Minus size={16} strokeWidth={3} /> : <Plus size={16} strokeWidth={3} />}
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 md:px-6 pb-6 -mt-2 text-base font-medium leading-relaxed border-t-2 border-[#0C0A09] pt-4">
                    {item.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
